import memoize from 'lodash/memoize';
export function sortBreakpoints(breakpoints) {
    const sortBreakpointsFn = (breakpointsToBeSorted) => Object.keys(breakpointsToBeSorted)
        .map((key) => Object.assign(breakpoints[key], { name: key }))
        .sort((b1, b2) => b1.sort - b2.sort);
    if (process.env.NODE_ENV === 'production') {
        return memoize(() => sortBreakpointsFn(breakpoints))();
    }
    return sortBreakpointsFn(breakpoints);
}
//# sourceMappingURL=sortBreakpoints.js.map